import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import ManufacturerList from "components/Manufacturer/ManufacturerList";
// import ConnectorsList from "components/Manufacturer/ConnectorsList";
import ManufacturerHeading from "components/Manufacturer/ManufacturerHeading";
import UploadExcelModel from "components/Manufacturer/Models/UploadExcelModel";
import { commonApis } from "stores/common/commonApis";
import DataUploaded from "components/Manufacturer/Models/DataUploaded";
import EnableDecebleManufacturer from "components/Manufacturer/VehicleDetails/EnableDesableManufacturer";
import { ManufacturerTableApi } from "stores/ManufacturerStore/ManufacturerApi";

class ManufacturerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "1",
      open: false,
      openData: false,
      ManufacturerConfirmDaialog: false,
      ManufacturerStatus: "",
      ManufacturerId: "",
    };

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(e, newValue) {
    this.setState({ value: newValue });
  }

  componentDidMount() {
    this.props.getManufacturerTableAction();
    this.props.getConnectorsTableAction();
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDataOpen = () => {
    this.setState({ openData: true });
  };

  handleDataClose = () => {
    this.setState({ openData: false });
  };

  handleStatusManufacturer = (id, status) => {
    this.setState({
      ManufacturerConfirmDaialog: true,
      ManufacturerStatus: status,
      ManufacturerId: id,
    });
  };

  handleManufacturerClose = () => {
    this.setState({ ManufacturerConfirmDaialog: false });
  };

  handleEnableClickManufacturer = async () => {
    const status = this.state.ManufacturerStatus;
    const id = this.state.ManufacturerId;

    if (status === 1) {
      await ManufacturerTableApi.ManufatureEnableDisableApi({ id, status: 0 });
      this.setState({ ManufacturerStatus: 0 });
      this.props.getManufacturerTableAction();
    } else {
      await ManufacturerTableApi.ManufatureEnableDisableApi({ id, status: 1 });
      this.props.getManufacturerTableAction();
    }

    this.setState({ ManufacturerConfirmDaialog: false });
  };

  handleImageChange = async (files) => {
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        try {
          const res = await commonApis.uploadAttachment({
            file: files[i],
            type: "IMAGE",
            attachment_of: "Station",
          });

          if (res.status === 1) {
            const { formData } = this.state;
            formData.attachment_ids.push(res.result.id);
            this.setState({ formData });
          }
        } catch (e) {
          console.log(e);
        } finally {
        }
      }
    }
  };

  render() {
    const data = this.props?.ManufacturerTableList?.result;
    // const connectors = this.props.ConnectorsTableList?.result;
    const loading = this.props.isloadingManufacturerTable;
    return (
      <>
        <Stack sx={{ marginTop: "1.2rem" }}>
          <Paper sx={{ p: 3, mt: 3.5 }}>
            <Stack sx={{ marginTop: "1.2rem" }}>
              <ManufacturerHeading onClickModel={this.handleClickOpen} />
              <UploadExcelModel
                handleClose={this.handleClose}
                open={this.state.open}
                onImageChange={this.handleImageChange}
                onClickModel={this.handleDataOpen}
              />
              <DataUploaded
                handleClose={this.handleDataClose}
                open={this.state.openData}
              />
            </Stack>
            <TabContext value={this.state.value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", marginTop: 3 }}
              >
                <Tabs
                  value={this.state.value}
                  onChange={this.handleTabChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="Manufacturer"
                    sx={{ textTransform: "none" }}
                    value="1"
                    index={0}
                  />
                  {/* <Tab
                    label="Connectors"
                    sx={{ textTransform: "none" }}
                    value="2"
                    index={1}
                  /> */}
                </Tabs>
              </Box>
              <TabPanel value={"1"} index={0} sx={{ px: 0 }}>
                <ManufacturerList
                  data={data}
                  loading={loading}
                  handleStatusManufacturer={this.handleStatusManufacturer}
                />
              </TabPanel>
              {/* <TabPanel value={"2"} index={1} sx={{ px: 0 }}>
                <ConnectorsList
                  data={connectors}
                  loading={this.props.isloadingConnectorsTable}
                />
              </TabPanel> */}
            </TabContext>
          </Paper>

          <EnableDecebleManufacturer
            open={this.state.ManufacturerConfirmDaialog}
            handleEnable={this.handleEnableClickManufacturer}
            handleclose={this.handleManufacturerClose}
            ConnectorsStatus={this.state.ManufacturerStatus}
          />
        </Stack>
      </>
    );
  }
}

export default ManufacturerContainer;
